import { ConfigConsumerProps } from '../config-provider/configConsumerProps';
export default {
  name: 'FcTree',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filterText: '',
    };
  },
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  render() {
    const { $attrs, $listeners, $scopedSlots, loading } = this;
    const { getPrefixCls } = this.configProvider;
    const prefixCls = getPrefixCls('', 'fc-tree');
    return (
      <div class={prefixCls}>
        {/* <perfect-scrollbar ref="scrollbar"> */}
        <el-tree
          {...{ props: $attrs }}
          {...{ on: $listeners }}
          {...{ scopedSlots: $scopedSlots }}
          ref="tree"
          empty-text=""
        ></el-tree>
        {loading && (
          <div class={`${prefixCls}-mask`}>
            <a-icon type="loading" class={`${prefixCls}-loading`} />
          </div>
        )}
        {/* </perfect-scrollbar> */}
      </div>
    );
  },
};
